// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","left":"Header_left__CF6SZ","logo":"Header_logo__UsziS","right":"Header_right__lXdsR"};